/*
  Footer navigation columns: collapsed on a phone, always open above it.

  WHY THIS EXISTS AT ALL. The 44px pointer floor is the whole point of the
  footer rebuild, and ten links at 44px is 440px of link. Measured at 390 the
  footer went from 862px to 1027px, and none of that is recoverable by
  tightening spacing: it IS the touch targets. Collapsing the three columns
  behind their own headings is the standard answer and it turns a 1027px scroll
  into three tappable rows.

  WHY THE MARKUP SHIPS OPEN AND THIS SCRIPT CLOSES IT, rather than the reverse.
  With JavaScript unavailable the footer must still show every link, which is
  exactly today's behaviour. Shipping closed and opening by script would mean a
  no-JS visitor gets a navigation they cannot open. Progressive enhancement runs
  in the direction that fails safe.

  WHY <details> RATHER THAN A SCRIPTED ACCORDION. It is keyboard operable,
  announced as a disclosure, and toggles without us writing a single ARIA
  attribute or key handler. The only thing left for script is deciding WHEN it
  should behave as a disclosure at all.

  DO NOT collapse these at desktop. Above 750 the columns sit side by side with
  room to spare, and a disclosure there hides navigation for no reason.
*/
(function () {
  'use strict';

  var BREAKPOINT = '(max-width: 749px)';

  function apply(list, isPhone) {
    for (var i = 0; i < list.length; i++) {
      var details = list[i];
      // Above the breakpoint the column is always open, and its summary stops
      // being a control: the CSS drops the chevron and the pointer cursor, and
      // this keeps the state honest so a resize cannot strand one closed.
      if (isPhone) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    }
  }

  function init() {
    var list = document.querySelectorAll('.saiko-footer__disclosure');
    if (!list.length) return;

    // matchMedia rather than a resize listener: this fires on the state change
    // we care about instead of on every pixel of a drag.
    var mq = window.matchMedia(BREAKPOINT);
    apply(list, mq.matches);

    var onChange = function (event) {
      apply(list, event.matches);
    };

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
    } else if (typeof mq.addListener === 'function') {
      // Safari below 14 never got addEventListener on MediaQueryList.
      mq.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
